module.exports = __webpack_public_path__ + "img/detail-wrap.8d7bbf6f.svg";